import { useAppSelector, useAppDispatch } from '../hooks'
import { CheckoutAppSelector } from '../store'
import { ExternalLinkIframeState, openExternalLinkIframe, closeExternalLinkIframe } from './reducer'

export const externalLinkIframeSelector: CheckoutAppSelector<ExternalLinkIframeState> = (state) => state.externalLinkIframe

export const useExternalLinkIframeData = (): ExternalLinkIframeState => useAppSelector(externalLinkIframeSelector)

export const useExternalLinkIframe = () => {
  const { url, isOpen } = useExternalLinkIframeData()
  const dispatch = useAppDispatch()

  return {
    url,
    isOpen,
    open: (url: string) => dispatch(openExternalLinkIframe(url)),
    close: () => dispatch(closeExternalLinkIframe()),
  }
}
